// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { upload16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-upload': IconUpload;
    }
}

/**
 * The icon component for the 'upload' icon
 */
export class IconUpload extends Icon {
    public constructor() {
        super(upload16X16);
    }
}

registerIcon('icon-upload', IconUpload);
export const iconUploadTag = 'nimble-icon-upload';
